import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const SocialLinks = makeShortcode("SocialLinks");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<div style={{
      textAlign: 'center'
    }}>
<SocialLinks justifyContent='center' fontSize={25} mdxType="SocialLinks" />
<div><p style={{
          fontSize: 16
        }}>Copyright © {new Date().getFullYear()} All rights reserved</p>
        <p style={{
          fontSize: 16
        }}>Made with Coffee ☕</p>
</div>
</div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      